import { t } from 'i18next';
import { useCallback, useEffect, useState } from 'react';
import { useAppDispatch } from 'store';
import { InvalidateField, invalidateList, ListSliceName } from 'store/invalidateListAction';
import { NotificationTypes, showNotification } from 'store/notifications/slice';

type Props = {
  sliceName?: ListSliceName;
  isListFetched?: boolean;
  field?: InvalidateField;
};

export const useRefreshList = ({ sliceName, isListFetched, field = 'isListFetched' }: Props) => {
  const dispatch = useAppDispatch();
  const [isRefreshRequested, setIsRefreshRequested] = useState<boolean>(false);

  if (!sliceName) return {
    refresh: () => { },
    isRefreshRequested: false,
  };

  const refresh = useCallback(() => {
    setIsRefreshRequested(true);
    dispatch(invalidateList({sliceName, field}));
  }, [dispatch, sliceName]);

  useEffect(() => {
    if (isListFetched && isRefreshRequested) {
      setIsRefreshRequested(false);
    }
  }, [dispatch, isListFetched, isRefreshRequested])


  return ({
    refresh,
    isRefreshRequested
  });
};
